interface InputIconProps {
  icon: string;
}

export const InputIcon = ({ icon }: InputIconProps) => {
  return <i className={`text-l block text-neutral-300 fa-fw ${icon}`} />;
};
